export const assistLabels = {
  operationalDescription: "descrição da empresa",
  targetAudience: "público atendido",
  differentiators: "diferenciais",
  businessObjectives: "objetivo do atendimento",
  commercialPolicies: "políticas comerciais",
  assistantRole: "função da assistente",
  openingMessage: "mensagem de boas-vindas",
  humanHandoff: "encaminhamento para a equipe",
  attendanceRules: "cuidados no atendimento"
} as const;

export type AssistedField = keyof typeof assistLabels;

// Remove only the boilerplate identifier that the provider sometimes echoes.
// Never rewrite the proposed business facts or fill missing information.
export function visibleSuggestion(raw: string): string {
  const keys = Object.keys(assistLabels).join("|");
  return raw.trim().replace(new RegExp(`^(?:proposta|sugest[aã]o)\\s+para\\s+(?:${keys})\\s*:\\s*`, "iu"), "").trim();
}

// A legacy summary has no reliable boundary between copy and owner guidance.
// Keep it informational rather than offering it as accept-ready business text.
export function fieldSuggestion(proposal: { suggestedText?: string; guidance?: string; alternatives?: string[]; summary?: string; pendingEvidenceIds?: string[] }): { suggestedText: string; guidance: string; alternatives?: string[]; pendingEvidenceIds?: string[] } {
  const alternatives = (proposal.alternatives ?? []).map((item) => item.trim()).filter(Boolean).slice(0, 2);
  const pendingEvidenceIds = [...new Set(proposal.pendingEvidenceIds ?? [])].filter(Boolean).slice(0, 24);
  return {
    suggestedText: proposal.suggestedText?.trim() ?? "",
    guidance: (proposal.suggestedText !== undefined ? proposal.guidance ?? "" : proposal.summary ?? "").trim(),
    ...(pendingEvidenceIds.length ? { pendingEvidenceIds } : {}),
    ...(alternatives.length ? { alternatives } : {})
  };
}

export function isPreparationAssistantLimitError(message: string): boolean {
  return /limite diário do assistente de preparação foi atingido/i.test(message);
}
